import { Box, Menu, MenuItem, styled } from '@material-ui/core';

export const AIGradientBgColor =
  'linear-gradient(92.34deg, #00101E 9.04%, #5B69CC 100.47%)';

export const StyledMenu = styled(Menu)(({ theme }) => ({
  marginTop: theme.spacing(1),

  '& .MuiPaper-root': {
    borderRadius: 8,
    border: `1px solid ${theme.palette.primary.main}`,

    '& ul': {
      padding: 0
    }
  }
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: 16,
  display: 'flex',
  alignItems: 'center',
  gridGap: theme.spacing(2)
}));

export const GradientIcon = styled(Box)({
  width: 32,
  height: 32,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: AIGradientBgColor
});
